import { Typography } from '@material-ui/core'

import {
  FullJobStatueAndDetails,
  Status
} from '../../types/BulkAccessManagement'
import { JobStatusForRateplan } from '../../types/rateplan'
import StatusBox from './StatusBox'
import useStyles from './styles/jobDetails.styles'

interface JobDetailsRowProps {
  data?: FullJobStatueAndDetails
  ratePlanData?: JobStatusForRateplan
}

export const JobDetailsModalRow: React.FC<JobDetailsRowProps> = ({
  data,
  ratePlanData
}) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowRoot}>
        {data && (
          <div className={classes.tableRowForModal}>
            <div className={classes.nameCell}>
              <Typography className={classes.tableItem} variant="body1">
                {data.email}
              </Typography>
            </div>
            <div className={classes.nameCell}>
              <Typography className={classes.tableItem} variant="body1">
                {data.Accommodations.length === 1
                  ? data.Accommodations[0]
                  : data.Accommodations[0] +
                    ' , ' +
                    data.Accommodations[1] +
                    ' ...'}
              </Typography>
            </div>
            <div>
              <Typography className={classes.tableItem} variant="body1">
                <StatusBox status={data.status as Status} />
              </Typography>
            </div>
          </div>
        )}
        {ratePlanData && (
          <div className={classes.tableRowForModal}>
            <div className={classes.nameCell}>
              <Typography className={classes.tableItem} variant="body1">
                {ratePlanData.rateplanName}
              </Typography>
            </div>
            <div className={classes.nameCell}>
              <Typography className={classes.tableItem} variant="body1">
                {ratePlanData.code}
              </Typography>
            </div>
            <div>
              <Typography className={classes.tableItem} variant="body1">
                <StatusBox status={ratePlanData.status as Status} />
              </Typography>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
